//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';

export const BlogHome = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background-back">

      <Box
        background="url('/images/satin-1.jpg')"
        height={{ min: '140px', max: 'auto' }}
        margin={{ top: 'none' }}
        pad={{ bottom: 'small' }} 
        style={{ backgroundSize: 'cover', backgroundPosition: 'center' }} 
      >
        <Box margin={{ top: 'none', left: 'large' }} pad={{ horizontal: 'small' }}>
          <PageHeader
            pad={{ top: '5px', bottom: '10px' }}
            title={<Text color="white" size="xxlarge" weight="bolder" style={{ fontWeight: 'bold' }}>HPE Tech Con Blog</Text>}
            subtitle={'Thoughts from our Tech Con community'}
            style={{ color: 'white' }}
            size='medium'
          />
        </Box>
      </Box>

      <PageContent flex="grow">

          <Heading size="small" weight="bold" margin={{ top: 'large' }}>Coming soon...</Heading>

      </PageContent>  

    </Page>
  );
};